import {IdentityProvider, OAuth2IdentityProvider} from "@bridge/okta-auth";

export class UndefinedIdentityProviderError extends Error {
  constructor(runtime: string) {
    super(`IdentityProvider for ${runtime} not defined.`);
    this.name = "UndefinedIdentityProviderError";
  }
}

export enum BridgeRuntime {
  PRODUCTION = "live-prod",
  NON_PRODUCTION = "live-nonprod",
  DZ_PRODUCTION = "dz-prod",
  DZ_NON_PRODUCTION = "dz-nonprod"
}

const providers: Record<BridgeRuntime, IdentityProvider> = {
  [BridgeRuntime.PRODUCTION]: new OAuth2IdentityProvider(
    `bridge-${BridgeRuntime.PRODUCTION}`,
    "https://authorize.coxautoinc.com",
    "aus132sv79JpAYinE357"
  ),
  [BridgeRuntime.NON_PRODUCTION]: new OAuth2IdentityProvider(
    `bridge-${BridgeRuntime.NON_PRODUCTION}`,
    "https://authorize.coxautoinc.com",
    "aus132uaxy2eomhmi357"
  ),
  /* Access DZ PROD using LIVE NON-PROD user authentication */
  [BridgeRuntime.DZ_PRODUCTION]: new OAuth2IdentityProvider(
    `bridge-${BridgeRuntime.DZ_PRODUCTION}`,
    "https://authorize.coxautoinc.com",
    "aus132uaxy2eomhmi357"
  ),
  /* Access DZ NON-PROD using DZ NON-PROD user authentication
   * Keep DZ NON-PROD on DZ authentication to preserve integration tests
   */
  [BridgeRuntime.DZ_NON_PRODUCTION]: new OAuth2IdentityProvider(
    `bridge-${BridgeRuntime.DZ_NON_PRODUCTION}`,
    "https://authorize.coxautoinc.com",
    "aus132uaxy2eomhmi357"
  )
};

export const bridgeOverride = (
  runtime: BridgeRuntime
): IdentityProvider | never => {
  const idp = providers[runtime];
  if (idp === undefined) {
    throw new UndefinedIdentityProviderError(runtime);
  }
  return idp;
};
